import React from "react";
import BaseComponent from "../../common/BaseComponent";
import NormalToolTip from "../toolTip";
import ReasonLogIcon from "../reasonLogIcon";
import EditIcon from "../EditIcon";
import ReturnReasonLogModal from "../returnReasonLogModal";
import "./index.scss";
import ReturnReasonDetailModal from "../returnReasonDetailModal";
import { checkOverflow } from "../viewNoteHyperLinkModal/utils";
import { debounce } from "lodash";
export default class ReturnReasonHypelink extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      showToolTip: false,
      returnReasonLog: this.props.reasonLog,
      isReasonLogModalOpen: false,
      isReasonDetailModalOpen: false,
      isEllipsis: false,
    };
    // @ts-ignore
    this.buttonRef = React.createRef();
  }

  componentDidMount() {
    this.checkEllipsis();
    window.addEventListener("resize", this.checkEllipsis);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.checkEllipsis);
  }

  checkEllipsis = debounce(() => {
    // @ts-ignore
    if (!this.buttonRef.current) return;
    // @ts-ignore
    const isTextEllipsis = checkOverflow(this.buttonRef.current);
    if (isTextEllipsis !== this.state.isEllipsis) {
      this.setState({ isEllipsis: isTextEllipsis });
    }
  });

  openToolTip = () => {
    this.setState({ showToolTip: true });
  };

  closeToolTip = () => {
    this.setState({ showToolTip: false });
  };

  handleReturnReasonLog = () => {
    this.setState({
      isReasonLogModalOpen: !this.state.isReasonLogModalOpen,
      returnReasonLog: this.state.isReasonLogModalOpen ? [] : this.props.reasonLog,
    });
  };

  handleClickViewReturnReason = () => {
    if (!this.state.isEllipsis) return;
    this.setState({
      isReasonDetailModalOpen: !this.state.isReasonDetailModalOpen,
    });
  };

  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevProps.reasonLog !== this.props.reasonLog) {
      this.setState({ returnReasonLog: this.props.reasonLog });
    }
    this.checkEllipsis();
  }

  render() {
    const {
      value,
      isShowEditBtn,
      handleReturnEditClick,
      isShowReasonLogIcon,
      rowindex,
      inputRef,
      isTable,
      isFileTableShow,
      isClientPathShow,
    } = this.props;

    const inputProps = {
      value: value,
      maxLength: 1000,
      isExpend: true,
      readonly: "readonly",
      className: "ReasonInput",
      iconClassName: "expendIcon",
      disabled: true,
      rowindex: rowindex,
      ref: inputRef,
      expendTextAreaClassName: "returnReasonDetail",
      isScrollExpend: true,
      isShowExpendIcon: false,
      isExpendNote: true,
      defaultExpend: true,
    };

    return (
      <>
        <div className="returnReasonInput">
          {!!value && (
            // @ts-ignore
            <p
              ref={(this as any).buttonRef}
              className={`returnReasonLink ${this.state.isEllipsis ? "ellipsisHover" : ""}`}
              onClick={this.handleClickViewReturnReason}
            >
              {value}
            </p>
          )}
          {isShowEditBtn && (
            <EditIcon
              className="reasonEditIcon"
              onClick={handleReturnEditClick}
              rowindex={rowindex}
              altText="Edit Return Reason"
            />
          )}
          {isShowReasonLogIcon && (
            <NormalToolTip
              title={<span>View previous Return Reason</span>}
              element={
                <div
                  onMouseEnter={() => this.openToolTip()}
                  onMouseLeave={() => this.closeToolTip()}
                >
                  <ReasonLogIcon
                    className="returnReasonLogIcon"
                    onClick={() => this.handleReturnReasonLog()}
                    altText="Return Reason Log"
                    rowindex={rowindex}
                  />
                </div>
              }
              placement="right"
              color="#3E6CB5"
              rowindex={rowindex}
            />
          )}
        </div>
        <ReturnReasonLogModal
          isReasonLogModalOpen={this.state.isReasonLogModalOpen}
          handleReturnReasonLog={this.handleReturnReasonLog}
          returnReasonLogData={this.state.returnReasonLog}
        />
        <ReturnReasonDetailModal
          isReasonDetailModalOpen={this.state.isReasonDetailModalOpen}
          handleReturnReasonDetail={this.handleClickViewReturnReason}
          returnReasonDetailData={value}
          inputProps={inputProps}
          isFileTableShow={isFileTableShow}
          isClientPathShow={isClientPathShow}
          isTable={isTable}
        />
      </>
    );
  }
}
